export * from './base-list-page.component'
export * from './base-page.component'
export * from './base.component'
export * from './base-webview-page.component'



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/abstract-components/index.ts